import React, { useEffect, useState } from 'react';
import './Dogpage.css';
import Button from './components/Button';
import DropdownComponent from './components/DropdownComponent';
import dogImg from './Images/dogimg_pets3.png';
import marsLogo from './Images/Mars-Logo.png';
import { setCookie, getCookie, handleRedirection, isMobile } from "./util/util";
import * as Constants from './util/constant';  // Import the constant file
import SplitPane from 'react-split-pane';
import { ColorRing } from 'react-loader-spinner';
import axios from './util/axiosConfig'; // Import the Axios configuration


export default function Dogpage() {
  const [loading, setLoading] = useState(true);
  const [mobile, setMobile] = useState(false);
  const [geolocationNotFound, setgeolocationNotFound] = useState(false);
  const [usersCountry, setUsersCountry] = useState('');
  const [usersCountryISO, setUsersCountryISO] = useState('');
  const [userCoordinates, setUserCoordinates] = useState(null);

  useEffect(() => {
    // Function to fetch the user's coordinates
    const fetchUserCoordinates = () => {
      if ('geolocation' in navigator) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            setUserCoordinates({ longitude, latitude });
          }, (error) => {
            console.error(error);
            console.error("Geolocation is not supported by your browser.");
            setgeolocationNotFound(true)
          });
        } else {
          console.error("Geolocation is not supported by your browser.");
          setgeolocationNotFound(true)
        }

      }
      else {
        console.error("Geolocation is not supported by your browser.");
        setgeolocationNotFound(true)
      }

    };

    if (getCookie('countryInfo') !== undefined) {
      //If cookie is present after user navigates to product pages, use country info from cookie
      let countryCookie = JSON.parse(getCookie('countryInfo'))
      let countryNameFromCookie = countryCookie[0]
      let countryISOFromCookie = countryCookie[1]
      setUsersCountry(countryNameFromCookie);
      setUsersCountryISO(countryISOFromCookie);
      setLoading(false);
    }
    else {
      // Call the function to fetch user coordinates
      fetchUserCoordinates();
    }
  }, []);


  useEffect(() => {
      // This useEffect watches for changes in userCoordinates and makes the API request when userCoordinates is updated.
      const fetchData = async () => {
      if (userCoordinates) {
        const { longitude, latitude } = userCoordinates;

        try {
          const response = await axios.get(`/reverseGeocode?api-version=2023-06-01&coordinates=${longitude},${latitude}&subscription-key=${Constants.geolocationApiKey}`);
          const countryname = response.data.features[0].properties.address.countryRegion.name;
          const countryISO = response.data.features[0].properties.address.countryRegion.iso;
          checkIfSEACountry(countryname, countryISO)
        }
        catch (error) {
          console.error(error)
          setUsersCountry(Constants.phCountryName)
          setUsersCountryISO(Constants.phCountryISO)
          let countryCookieArray = [Constants.phCountryName, Constants.phCountryISO]
          setCookie('countryInfo', countryCookieArray);
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [userCoordinates]);

  const checkIfSEACountry = (countryname, countryISO) => {
    if (countryISO !== undefined && (countryISO === Constants.phCountryISO || countryISO === Constants.myCountryISO || countryISO === Constants.thCountryISO || countryISO === Constants.idCountryISO || countryISO === Constants.vnCountryISO || countryISO === Constants.sgCountryISO)) {
      setUsersCountry(countryname);
      setUsersCountryISO(countryISO);
      const cookieArray = [countryname, countryISO]
      setCookie('countryInfo', cookieArray);
      setLoading(false);
    }
    else {
      // If user is not from any of 6 places --> set user info to Philippines
      setUsersCountry(Constants.phCountryName)
      setUsersCountryISO(Constants.phCountryISO)
      let countryCookieArray = [Constants.phCountryName, Constants.phCountryISO]
      setCookie('countryInfo', countryCookieArray);
      setLoading(false);
    }
  }


  useEffect(() => {
    setMobile(isMobile());
  }, []);


  const handleClickofPedigree = () => {
    let url = '';

    switch (usersCountryISO) {
      case Constants.vnCountryISO:
        url = Constants.pedigree_vn;
        break;
      case Constants.thCountryISO:
        url = Constants.pedigree_th;
        break;
      case Constants.myCountryISO:
        url = Constants.pedigree_my;
        break;
      case Constants.phCountryISO:
        url = Constants.pedigree_ph;
        break;
      case Constants.idCountryISO:
        url = Constants.pedigree_id;
        break;
      case Constants.sgCountryISO:
        url = Constants.pedigree_sg;
        break;
      default: url = Constants.pedigree_ph;
    }

    handleRedirection(url)

  }

  const handleClickofCesar = () => {
    let url = '';

    switch (usersCountryISO) {
      case Constants.vnCountryISO:
        url = Constants.cesar_vn;
        break;
      case Constants.thCountryISO:
        url = Constants.cesar_th;
        break;
      case Constants.myCountryISO:
        url = Constants.cesar_my;
        break;
      case Constants.phCountryISO:
        url = Constants.cesar_ph;
        break;
      case Constants.idCountryISO:
        url = Constants.cesar_id;
        break;
      case Constants.sgCountryISO:
        url = Constants.cesar_sg;
        break;
      default: url = Constants.cesar_ph;
    }

    handleRedirection(url)

  }

  // IAMS code commented : to be used in next release
  const handleClickofIAMS = () => {
    let url = '';
    switch (usersCountryISO) {
      case Constants.vnCountryISO:
        //IAMS VN url missing
        url = Constants.iams_vn;
        break;
      case Constants.thCountryISO:
        url = Constants.iams_th;
        break;
      case Constants.myCountryISO:
        url = Constants.iams_my;
        break;
      case Constants.phCountryISO:
        url = Constants.iams_ph;
        break;
      case Constants.idCountryISO:
        url = Constants.iams_id;
        break;
      case Constants.sgCountryISO:
        url = Constants.iams_sg;
        break;
      default: url = Constants.iams_ph;
    }

    handleRedirection(url)

  }


  const handleCountryChange = (country, iso) => {
    setUsersCountry(country)
    setUsersCountryISO(iso)
    let countryCookieArray = [country, iso]
    setCookie('countryInfo', countryCookieArray);
  }




  // -------Render--------

  return (
    <div>
      {
        //--------------Mobile---------------------------  
        mobile ?
        (
          <div className='container_mob'>
            <div className='top'>
              <img src={marsLogo} className='image1' alt="LogoMars" />
              <img src={dogImg} className='image2' alt="dog_image" />
            </div>

            <div className='bottom'>
              {geolocationNotFound ? (
                <div className='div-50'>
                  <div style={{ display: 'block', justifyContent: 'center', alignItems: 'center', padding: '15%' }}>
                    <span style={{ color: "white", fontSize: '15px' }}>Geolocation is disabled on your browser. To view our products enable site permissions for location and reload screen.</span>
                  </div>
                </div>
              )
                :
                (
                  <div className='div-50'>
                    {loading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                        <ColorRing
                          visible={true}
                          height="60"
                          width="60"
                          ariaLabel="blocks-loading"
                          wrapperStyle={{}}
                          wrapperClass="blocks-wrapper"
                          colors={['#346f9f', '#346f9f', '#346f9f', '#346f9f', '#346f9f']}
                        />
                      </div>
                    )
                      : (
                        <div>
                          <div className='textprod'>
                            <span className='textprodText'>View products</span>
                          </div>
                          <div className="buttonDiv" >
                            <Button onClick={handleClickofPedigree} className="button button1" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/pedigree_logo.png')} imageAlt='pedigree_logo' />
                            <Button onClick={handleClickofCesar} className="button button2" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/cesar_logo.png')} imageAlt='cesar_logo' />
                            <Button onClick={handleClickofIAMS} className="button button3" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/iams_logo.png')} imageAlt='iams_logo' />
                          </div>

                          <div className='footer-wrapper'>
                            <div className='dropdown'>
                              <span style={{ marginRight: '5px', color: "white" }}>Region</span>
                              <DropdownComponent initialValue={usersCountry} onCountryChange={handleCountryChange} />
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                )}

            </div>
          </div>
          )
          //--------------Desktop------------------
          :
          (
            <SplitPane split='horizontal' defaultSize={"50%"} >
              <SplitPane split='vertical' defaultSize={"50%"} style={{ zIndex: "999", bottom: "-8%" }}>
                <img src={marsLogo} className='logoImgpick' alt="LogoMars" />
                <img src={dogImg} className='dogImgStyle' alt="dog_img" />
              </SplitPane>

              {geolocationNotFound ? (
                <div className='div-50'>
                  <div style={{ display: 'block', justifyContent: 'center', alignItems: 'center', padding: '5%' }}>
                    <p style={{ color: "white", fontSize: '15px' }}>Geolocation is disabled on your browser. </p>
                    <p style={{ color: "white", fontSize: '15px' }}>To view our products enable site permissions for location and reload screen.</p>
                  </div>
                </div>
              )
                :
                (

                  <div className='div-50'>
                    {loading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                        <ColorRing
                          visible={true}
                          height="60"
                          width="60"
                          ariaLabel="blocks-loading"
                          wrapperStyle={{}}
                          wrapperClass="blocks-wrapper"
                          colors={['#346f9f', '#346f9f', '#346f9f', '#346f9f', '#346f9f']}
                        />
                      </div>
                    )
                      : (
                        <div>
                          <div className='textprod'>
                            <span style={{ color: "white", marginTop: "10px" }}>View products</span>
                            <div className="buttonDiv" >
                              <Button onClick={handleClickofPedigree} className="button button1" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/pedigree_logo.png')} imageAlt='pedigree_logo' />
                              <Button onClick={handleClickofCesar} className="button button2" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/cesar_logo.png')} imageAlt='cesar_logo' />
                              <Button onClick={handleClickofIAMS} className="button button3" centerImage={true} labelText={false} imageStyle="image-class" imageURL={require('./Images/iams_logo.png')} imageAlt='iams_logo' />
                            </div>
                          </div>

                          <div className='footer-wrapper'>
                            <div className='dropdown'>
                              <span style={{ marginRight: '5px', color: "white" }}>Region</span>
                              <DropdownComponent initialValue={usersCountry} onCountryChange={handleCountryChange} />
                            </div>
                          </div>
                        </div>
                      )}

                  </div>
                )}

            </SplitPane>
          )
      }
    </div>

  );
}

